import WhatsAppIcon from "@/components/site/WhatsAppIcon";
import { CONTACT_INFO } from "@/data/content";

export default function FloatingWhatsApp() {
  return (
    <a
      href={CONTACT_INFO.whatsapp.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message Maqam on WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 group"
      style={{ boxShadow: "0 12px 30px -8px rgba(37, 211, 102, 0.55)" }}
    >
      <span
        className="hidden md:inline-flex items-center gap-2 rounded-full pl-4 pr-5 py-3 text-white font-semibold text-sm transition-transform group-hover:-translate-y-0.5"
        style={{ background: "#25D366" }}
      >
        <WhatsAppIcon size={22} brand={false} className="text-white" />
        WhatsApp Us
      </span>
      <span
        className="md:hidden inline-flex items-center justify-center w-14 h-14 rounded-full transition-transform group-hover:-translate-y-0.5"
        style={{ background: "#25D366" }}
      >
        <WhatsAppIcon size={28} brand={false} className="text-white" />
      </span>
    </a>
  );
}
